import { ReactNode } from 'react'
import { ProjectProvider } from '@/contexts/project-context'
import UserProfileCheck from '@/components/user-profile-check'

export default function AuthWrapper({ children }: { children: ReactNode }) {
  return (
    <UserProfileCheck>
      <ProjectProvider>
        {children}
      </ProjectProvider>
    </UserProfileCheck>
  )
}